import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getTabs, productsCardTabs } from '../constants'

const useProductTabs = (products, sizeRecommendationsCount) => {
  const { t } = useTranslation()
  const [selectedTab, setSelectedTab] = useState(productsCardTabs.allProducts)

  const productsWithPosition = products?.map((product, position) => ({ ...product, originalPosition: position }))

  const sizingIssueProducts = sizeRecommendationsCount
    ? productsWithPosition?.filter(product => product.has_size_recommendation)
    : []

  const filteredProducts = selectedTab === productsCardTabs.sizingIssues ? sizingIssueProducts : productsWithPosition

  const tabs = getTabs(t, products?.length, sizeRecommendationsCount)

  return {
    selectedTab,
    setSelectedTab,
    filteredProducts,
    sizingIssueProducts,
    tabs,
  }
}

export default useProductTabs
